<template>
  <div class="meet-box">
    <div class="title">
      <span :class="param.type === 2 ? 'active' : ''" @click="changeTab(2)"
        >主办会议</span
      >
      <span :class="param.type === 1 ? 'active' : ''" @click="changeTab(1)"
        >协办会议</span
      >
      <span :class="param.type === 3 ? 'active' : ''" @click="changeTab(3)"
        >承办会议</span
      >
    </div>
    <div class="meet-content" v-if="total > 0">
      <div class="meet-list" v-for="item in list" :key="item.id">
        <div class="item-logo">
          <img v-lazy="$global.imgUrl + item.cover" alt="" />
        </div>
        <div class="item-content">
          <h3 style="cursor: pointer;" @click="goDetail(item)" v-html="item.title"></h3>
          <p>
            <img src="@/assets/img/qietu/meetIcon.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">主办单位：</span>
            <span
              style="margin-right: 5px"
              v-for="i in item.orgs"
              :key="i.orgId"
              ><span v-if="param.type === i.type">{{ i.name }} </span></span
            >
          </p>
          <p>
            <img src="@/assets/img/qietu/meetIcon2.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">时间：</span>
            <span>{{ item.beginTime.slice(0, 10) }}</span>
          </p>
          <p>
            <img src="@/assets/img/qietu/meetIcon1.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">地点：</span>
            <span>{{ item.province }} {{ item.city }} {{ item.address }}</span>
          </p>
        </div>
      </div>
      <Page
        v-if="total > 5"
        style="text-align: center"
        prev-text="上一页"
        next-text="下一页"
        :current="param.pageNo"
        :page-size="5"
        :total="total"
        @on-change="pageChange"
      />
    </div>
    <div class="empty" v-else>暂无会议</div>
    <Modal v-model="qrCodeModal" title="手机查看完整会议内容" class="" @on-cancel="qrCodeModal = false" :footer-hide="true">
      <div style="width:200px;height:200px;margin:20px auto;">
        <div id="qrcodeArea" ref="qrcodeArea">
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "meet",
  created() {
    this.getMeetList();
  },
  data() {
    return {
      qrCodeModal: false,
      list: [],
      param: {
        orgId: this.$route.query.id,
        type: 2,
        pageNo: 1,
        pageSize: 5,
      },
      total: 0,
    };
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "meetingDetails",
        query: {
          id: e.id,
          type: 8,
          goodsId:e.goodsId,
        },
      });
      window.open(routeUrl.href, "_blank");
      // this.qrCodeModal = true;
      // if (!this.qr) {
      //   this.$nextTick(() => {
      //     // 生成H5
      //     this.qr = new QRCode(this.$refs.qrcodeArea, {
      //       width: 200,
      //       height: 200, // 高度
      //       text: location.protocol+'//'+location.hostname + routeUrl.href, // 二维码内容
      //     });

      //   })
      // }
    },
    pageChange(pageNo) {
      this.param.pageNo = pageNo;
      this.getMeetList();
    },
    changeTab(type) {
      this.param.type = type;
      this.getMeetList();
    },
    async getMeetList() {
      const res = await this.$apis.recomendServe.getListByOrgId(this.param);
      this.total = +res.data.total;
      this.list = [...res.data.list];
    },
  },
};
</script>

<style lang="scss" scoped>
.meet-box {
  .title {
    font-size: 22px;
    color: #666;
    .active {
      color: #1d52eb;
    }
    span {
      margin-right: 30px;
      cursor: pointer;
    }
  }
  .meet-content {
    margin-top: 45px;
    .meet-list {
      display: flex;
      margin-bottom: 20px;
      padding-bottom: 20px;
      width: 100%;
      border-bottom: 1px solid #eee;
      .item-logo {
        margin-right: 10px;
        width: 150px;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          background-color: #f4f4f4;
        }
      }
      .item-content {
        flex: 1;
        h3 {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 400;
          color: #263d78;
        }
        p {
          margin-bottom: 20px;
          font-size: 14px;
          color: #000000;
          img {
            margin-right: 7px;
            width: 20px;
            height: 20px;
            vertical-align: middle;
          }
        }
      }
      &:last-child {
        border: none;
      }
    }
  }
  .empty {
    padding: 60px 0;
    text-align: center;
    font-size: 16px;
    color: #666666;
  }
}
</style>